/* eslint-disable @atlassian/i18n/no-literal-string-in-jsx */
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

// @ts-ignore
import annieClaire from '../assets/annieClaire.png';
// @ts-ignore
import austinLambert from '../assets/austinLambert.png';
// @ts-ignore
import fidelisEjima from '../assets/fidelisEjima.png';
// @ts-ignore
import oliviaYang from '../assets/oliviaYang.png';
import { messages as contactLibraryMessages } from '../i18n/contact-library-messages.ts';

import { tagBackgroundColors, tagBorderColors, templateStyles } from './styles.ts';

const ContactLibrary: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={348}
      height={142}
      fill="none"
    >
      <g clipPath="url(#contactLibrary-a)">
        <rect width={336} height={142} fill={templateStyles['background']} rx={3} />
        <g filter="url(#contactLibrary-b)">
          <g clipPath="url(#contactLibrary-c)">
            <rect
              width={80.94}
              height={174.28}
              x={2.45}
              y={3.67}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <g clipPath="url(#contactLibrary-d)">
              <path fill="#FFA900" d="M4.92 6.14h76V59.9h-76z" />
              <mask
                id="contactLibrary-f"
                width={58}
                height={50}
                x={14}
                y={8}
                maskUnits="userSpaceOnUse"
                style={{ maskType: 'alpha' }}
              >
                <path
                  fill="url(#contactLibrary-e)"
                  d="m14.85 56.14-.24 1.46h56.62v-2.67l-.97-.85-.85-.6-.97-.37-1.33-.36-1.1-.6-1.33-.62-.97-.6V49.1l-.24-1.21V45.1l-.12-1.46-.25-1.57-.24-1.21-.48-1.46-.49-1.21-.85-1.34-.72-1.33-.85-1.33-.73-1.22-.85-1.2v-1.46l-.12-1.94-.12-1.46-.12-1.82-.24-1.45-.25-1.1-.24-.72-.6-1.45-.61-1.34-.37-.97-.48-.73-.36-.6-.49-.97-.85-1.21-1.09-1.1-.73-.72-1.33-1.1-.6-.48-1.34-.85-.73-.36-1.09-.49-1.21-.36-.73-.12-.85-.24-.97-.12h-2.06l-.97.24-.85.24-.36.36-.36.85h-2.3l-.74.49-1.57 1.33-1.34 1.58-1.45 1.82-1.21 2.42-.97 1.94-.85 2.55-.6 2.3-.61 1.7-.49 1.45-.12 1.46v1.82l.24 1.45.49 1.46.48.84.6 1.22.5.97.6.97.24.85.12.6v.37l-.36.24-1.1.6-.84.49-.6.48-.73.61-.61.6-.36.37-1.1.12-.96.12-.97.37h-.61l-.85.24-.48.48-.49 1.1-.48 1.2-.49 1.46-.6 1.21-.73 1.34-.61 1.82-.48 1.57-.49 1.82Z"
                />
              </mask>
              <g mask="url(#contactLibrary-f)">
                <path fill="url(#contactLibrary-g)" d="M12.79 7.4h58.44v50.19H12.79z" />
              </g>
            </g>
            <rect
              width={33.57}
              height={8.22}
              x={7.34}
              y={62.32}
              fill={templateStyles['userBackground']}
              rx={4.11}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M11.02 64.45a1.99 1.99 0 1 0 1 3.7l.22.4a2.45 2.45 0 1 1 1.22-2.12c0 .26-.08.55-.25.77a.95.95 0 0 1-.77.41.68.68 0 0 1-.65-.43c-.35.41-.92.58-1.39.31-.54-.3-.63-1.04-.31-1.6.32-.54 1-.83 1.54-.52a1.05 1.05 0 0 1 .5 1c0 .2 0 .42.07.58.02.08.06.13.1.16.02.02.07.05.14.05.17 0 .3-.09.4-.23.1-.14.17-.33.17-.5 0-1.1-.9-1.98-2-1.98Zm.65 1.86c0-.24-.1-.44-.27-.54-.26-.15-.68-.04-.91.36-.23.4-.12.82.14.97.27.15.69.04.92-.36a.9.9 0 0 0 .12-.4v-.03Z"
              clipRule="evenodd"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={14.69} y={67.52}>
                Annie Clare
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={7.34} y={78.19}>
                {formatMessage(contactLibraryMessages['contact-library.entry-1-cell-3'])}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={7.34} y={88.86}>
                {formatMessage(contactLibraryMessages['contact-library.entry-1-cell-4'])}
              </tspan>
            </text>
            <rect
              width={28.7}
              height={5.82}
              x={7.49}
              y={94.49}
              fill={tagBackgroundColors['blueLight']}
              rx={0.77}
            />
            <rect
              width={28.7}
              height={5.82}
              x={7.49}
              y={94.49}
              stroke={tagBorderColors['blueLight']}
              strokeWidth={0.3}
              rx={0.77}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={9.66} y={98.48}>
                {formatMessage(
                  contactLibraryMessages['contact-library.field-5-select-option-1']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={7.34} y={108.1}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-1-cell-6']
                ).substring(0, 30)}
              </tspan>
              <tspan x={6.34} y={114.22}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-1-cell-6']
                ).substring(30, 63)}
              </tspan>
              <tspan x={6.34} y={120.34}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-1-cell-6']
                ).substring(63, 96)}
              </tspan>
              <tspan x={6.34} y={126.46}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-1-cell-6']
                ).substring(96, 128)}
              </tspan>
              <tspan x={6.34} y={132.58}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-1-cell-6']
                ).substring(128, 158)}
              </tspan>
              <tspan x={6.34} y={138.7}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-1-cell-6']
                ).substring(158, 188)}
              </tspan>
            </text>
          </g>
        </g>
        <g filter="url(#contactLibrary-h)">
          <g clipPath="url(#contactLibrary-i)">
            <rect
              width={80.94}
              height={174.28}
              x={85.84}
              y={3.67}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <g clipPath="url(#contactLibrary-j)">
              <path fill="#82B536" d="M88.3 6.14h76.07V59.9H88.3z" />
              <mask
                id="contactLibrary-k"
                width={52}
                height={50}
                x={97}
                y={9}
                maskUnits="userSpaceOnUse"
                style={{ maskType: 'alpha' }}
              >
                <path
                  fill="#D9D9D9"
                  d="m99.07 54.6-1.19.52v3.29h50.67v-1.05l-.13-1.06-.27-.79-.26-.65-.52-.8-.66-.78-.8-.53-.91-.66-.8-.52-.91-.53h-1.45l-.13-.13-.8-.53-.78-.26-.66-.26.4-1.98.39-2.1.26-1.85.26-1.05.27-1.18.26-1.19.26-1.18.27-1.05.26-.27.66-.4.92-.12.66-.4.52-.4.53-.65.26-.8.27-.65.13-.92.13-1.18.13-.8.26-1.05.14-1.05.13-1.05-.27-.66-.39-.53-.4-.52-.39-.27-.53-.65v-.93l.14-1.05v-3.29l-.14-.79-.39-.79-.53-.92-.13-.79-.26-.26v-.4l-.4-.65-.52-.53-.66-.4-.53-.26-.4-.79-.52-.66-.79-.4-.4-.52-.52-.4-.66-.52-.66-.13-1.05-.92h-1.05l-.66-.26-1.05-.27h-1.05l-.92-.13-.66.13-.8.27h-.52l-.92-.4h-.92l-.92.26-.8.27-.78.13-.92.66-1.32.26-.92.92-.79.8-.92 1.17-1.19 1.45-.78 1.19-.27 1.18-.26 1.32v.92l-.13 1.97-.14 1.58.14 1.58v2.24l.13 2.1-.13 2.64-.14 2.36v1.71l.27 1.58.4 1.85.39 1.58.52 1.44.53 1.06.8 1.05-.8.92-.92.79-.79.66-.79.4-1.05.39-1.32.66-1.18.26-1.19.4h-.92l-1.31.26-1.32.26-1.32.53-1.31.65-.92.66h-3.29l-.8.26-.78.66-.8.8-.78.91Z"
                />
              </mask>
              <g mask="url(#contactLibrary-k)">
                <path fill="url(#contactLibrary-l)" d="M97.75 9.46h64.75v48.95H97.75z" />
              </g>
            </g>
            <rect
              width={41.57}
              height={8.22}
              x={90.73}
              y={62.32}
              fill={templateStyles['userBackground']}
              rx={4.11}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M94.4 64.44a1.99 1.99 0 1 0 1 3.71l.23.4a2.45 2.45 0 1 1 1.22-2.12c0 .26-.08.54-.25.77a.95.95 0 0 1-.77.41.68.68 0 0 1-.65-.43c-.35.4-.92.58-1.39.31-.54-.31-.63-1.04-.31-1.6.32-.55 1-.83 1.54-.52a1.05 1.05 0 0 1 .5.99c0 .21 0 .43.06.59.03.08.07.13.1.15.03.03.07.05.15.05.16 0 .3-.08.4-.22a.9.9 0 0 0 .16-.5c0-1.1-.89-1.99-1.99-1.99Zm.66 1.87c0-.25-.1-.44-.27-.54-.27-.15-.69-.04-.92.35-.23.4-.11.82.15.97.26.15.68.04.91-.35a.9.9 0 0 0 .13-.4v-.03Z"
              clipRule="evenodd"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={98.08} y={67.51}>
                Austin Lambert
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={90.73} y={78.19}>
                {formatMessage(contactLibraryMessages['contact-library.entry-2-cell-3'])}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={90.73} y={88.86}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-2-cell-4']
                ).substring(0, 32)}
              </tspan>
              <tspan x={90.73} y={94.98}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-2-cell-4']
                ).substring(32)}
              </tspan>
            </text>
            <rect
              width={27.7}
              height={6.7}
              x={90.88}
              y={100.48}
              fill={tagBackgroundColors['greenLight']}
              rx={0.77}
            />
            <rect
              width={27.7}
              height={6.7}
              x={90.88}
              y={100.48}
              stroke={tagBorderColors['greenLight']}
              strokeWidth={0.3}
              rx={0.77}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={93.11} y={104.92}>
                {formatMessage(
                  contactLibraryMessages['contact-library.field-5-select-option-2']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={90.73} y={114.98}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-2-cell-6']
                ).substring(0, 35)}
              </tspan>
              <tspan x={89.73} y={121.1}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-2-cell-6']
                ).substring(35, 67)}
              </tspan>
              <tspan x={89.73} y={127.22}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-2-cell-6']
                ).substring(67, 101)}
              </tspan>
              <tspan x={89.73} y={133.34}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-2-cell-6']
                ).substring(101, 131)}
              </tspan>
              <tspan x={89.73} y={139.46}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-2-cell-6']
                ).substring(131, 164)}
              </tspan>
            </text>
          </g>
        </g>
        <g filter="url(#contactLibrary-m)">
          <g clipPath="url(#contactLibrary-n)">
            <rect
              width={80.94}
              height={174.28}
              x={169.22}
              y={3.67}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <g clipPath="url(#contactLibrary-o)">
              <path fill="#1868DB" d="M171.7 6.14h76.06V59.9H171.7z" />
              <mask
                id="contactLibrary-p"
                width={55}
                height={58}
                x={183}
                y={8}
                maskUnits="userSpaceOnUse"
                style={{ maskType: 'alpha' }}
              >
                <path
                  fill="#D9D9D9"
                  d="m183.66 64.24-.22 1.49h53.43v-.8l.23-.58v-1.03l-.23-.7-.23-.8-.11-1.38-.7-1.15-.22-.69-.46-.91-.7-.92-.91-1.04-.57-.8-.7-.8-.57-.81-.57-.58-.8-.57-.7-.58-.69-.57-.8-.69-.8-.8-1.27-.92-.69-.8-.34-.81-.23-.46-.35-.8-.11-1.16.34-1.72.12-1.15.22-1.03.23-2.19.12-1.49.34-2.3.24-1.5.22-2.06.12-1.5.11-1.26v-5.17l-.11-.92-.23-1.26-.23-1.15-.34-1.04-.35-.8-.23-.8-.46-1.04-.34-.69-.35-.8-.57-.8-.58-.7-.57-.69-.7-.69-.57-.57-.8-.58-.8-.57-.81-.58-.8-.46-.8-.34-.93-.11h-2.53l-.69.11-.34-.11h-1.95l-1.27.34-.8.34-1.15.58-1.04.69-1.03.69-1.03.92-.92.8-1.15 1.15-1.04 1.38-.8 1.38-.58 1.26-.57 1.73-.58 1.6-.34 1.61-.57 2.19-.35 1.38-.57 2.18-.46 1.5-.58 1.72-.46 1.5-.46 1.37-.46.8-.46.81-.57.92-.35.57-.46.8-.11.47v2.3l.11 1.5.23 1.37.35 1.15.34.92.35 1.15h-.7l-.68.57-.7.35-.91.46-.8.23-.92.69-.92.57-.8.69-.47.69-.23.69-.23 1.03-.46 1.04-.57 1.5-.12 1.03-.46 1.26-.34 1.26-.23 1.38-.23 1.38-.12 1.73Z"
                />
              </mask>
              <g mask="url(#contactLibrary-p)">
                <path
                  fill="url(#contactLibrary-q)"
                  d="M175.85 8.27h71.48v57.46h-71.48z"
                />
              </g>
            </g>
            <rect
              width={32.57}
              height={8.22}
              x={174.12}
              y={62.32}
              fill={templateStyles['userBackground']}
              rx={4.11}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M177.8 64.44a1.99 1.99 0 1 0 .99 3.71l.23.4a2.44 2.44 0 0 1-3.68-2.12 2.45 2.45 0 1 1 4.9 0c0 .26-.09.54-.25.77a.94.94 0 0 1-.77.41.68.68 0 0 1-.65-.43c-.35.4-.92.58-1.39.31-.54-.31-.63-1.04-.31-1.6.31-.55 1-.83 1.53-.52a1.05 1.05 0 0 1 .5.99c0 .21.01.43.07.59.03.08.06.13.1.15.03.03.07.05.15.05.16 0 .3-.08.4-.22a.9.9 0 0 0 .16-.5c0-1.1-.89-1.99-1.99-1.99Zm.64 1.87c.01-.25-.1-.44-.26-.54-.27-.15-.69-.04-.92.35-.23.4-.11.82.15.97.26.15.68.04.91-.35a.9.9 0 0 0 .12-.4v-.03Z"
              clipRule="evenodd"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={181.46} y={67.51}>
                Olivia Yang
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={174.12} y={78.19}>
                {formatMessage(contactLibraryMessages['contact-library.entry-3-cell-3'])}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={174.12} y={88.86}>
                {formatMessage(contactLibraryMessages['contact-library.entry-3-cell-4'])}
              </tspan>
            </text>
            <rect
              width={32.7}
              height={5.82}
              x={174.27}
              y={94.48}
              fill={tagBackgroundColors['yellowLight']}
              rx={0.77}
            />
            <rect
              width={32.7}
              height={5.82}
              x={174.27}
              y={94.48}
              stroke={tagBorderColors['yellowLight']}
              strokeWidth={0.3}
              rx={0.77}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={176.51} y={98.48}>
                {formatMessage(
                  contactLibraryMessages['contact-library.field-5-select-option-3']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={174.12} y={108.1}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-3-cell-6']
                ).substring(0, 30)}
              </tspan>
              <tspan x={173.12} y={114.22}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-3-cell-6']
                ).substring(30, 63)}
              </tspan>
              <tspan x={173.12} y={120.34}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-3-cell-6']
                ).substring(63, 95)}
              </tspan>
              <tspan x={173.12} y={126.46}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-3-cell-6']
                ).substring(95, 129)}
              </tspan>
              <tspan x={173.12} y={132.58}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-3-cell-6']
                ).substring(129, 164)}
              </tspan>
              <tspan x={174.12} y={138.7}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-3-cell-6']
                ).substring(164, 199)}
              </tspan>
              <tspan x={174.12} y={144.82}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-3-cell-6']
                ).substring(199)}
              </tspan>
            </text>
          </g>
        </g>
        <g filter="url(#contactLibrary-r)">
          <g clipPath="url(#contactLibrary-s)">
            <rect
              width={80.94}
              height={174.28}
              x={252.61}
              y={3.67}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <g clipPath="url(#contactLibrary-t)">
              <path fill="#BF63F3" d="M255.09 6.15h76.04v53.79H255.1z" />
              <mask
                id="contactLibrary-u"
                width={72}
                height={58}
                x={257}
                y={8}
                maskUnits="userSpaceOnUse"
                style={{ maskType: 'alpha' }}
              >
                <path
                  fill="#D9D9D9"
                  d="m258.49 57-1.24 1.4v6.8h71.42l-.47-.62-.3-.62-.32-.93-.46-.93-.62-1.39-.3-.77-.47-.93-.31-1.08-.46-1.08-.47-.93-.77-.93-.93-.92-.93-.78-.77-.46-.62-.31-.62-.46-1.08-.62-.92-.78-.93-.46-.93-.46-1.24-.47-.77-.3-.93-.16-.77-.16-1.08-.3-.16-.16-.77-.77-.93-.7-.77-.85-1.24-1.23-.92-.93-.47-.47.31-.77.62-.62.3-.77.47-.77.16-.47.15-.61v-1.55l.16-.3.15-.47.31-.16.46-.3.31-.32v-.46l-.15-.3-.31-.16-.15-.31v-.31l.15-.47.15-.46.16-.46.3-.62v-2.63l-.15-.46-.15-.31-.31-.16h-.31l-.46.16v-1.24l.3-.15.16-.31v-.31l.16-.47.15-.61v-.31l.15-.31v-1.08l.16-.31v-.31l-.16-.47V23l.16-.47v-.62l.15-.62.31-.3v-.31l-.3-.16-.16-.3-.16-.47v-.62l-.15-.3-.15-.63v-.62l.15-.46-.15-.3v-.32l-.16-.46-.46-.16-.16-.3-.15-.31h-.47l-.46-.16v-1.54l-.16-.31-.3-.47h-.62v-.15l-.31-.31h-.93v-.31l-.15-.31-.47-.15-.46-.16-.16-.3-.3-.16h-.47l-.3-.16-.16-.3h-.31l-.62-.32h-.3l-.16.16-.31.15-.47-.15-.15-.31v-.46l-.77-.47-.31-.3-.47-.16h-.61v.3l-.16.16h-.77l-.16-.3h-1.23l-.31.3h-.47l-.15.16h-.62l-.15-.16-.31.16-.31.15v.31l-.16.16h-.46l-.15-.31-.31-.16-.47.16V10l-.3.3-.32-.15-.3-.15-.31.3-.16.16-.15.16h-.31l-.16.3-.3.16-.47-.15-.31.15-.3.62-.47-.15-.62.15-.16.15-.3.16-.16.46-.46.31-.16.62-.3.31v.62l-.32.3-.3.78v.62l-.16.15-.3.47-.16.46-.16.62v.62l-.15.62-.16.3v1.4l-.15.92-.16.62v2.63l.16.46.15.47.16.62.3.61-.15.62-.15-.3-.47-.16h-.3l-.31.3-.31.32-.16.61-.15.93v2.33l.15.62v.62l.16.46.15.47v1.08l.15.46.31.16h.31l.47-.16.62-.3v1.7h-.16l-.62.15-.62.15-.77.31-.46.16-.77.46-.62.46-.47.78-.15 1.08-.31 1.08-.16 1.08v.62l-.15.77-.3.47v.77l-.16.46-.47.16-1.23.62-1.4.77-1.39.77-1.39.77-1.39.78-1.24.62-1.39.61-1.7.78-1.54.62-1.4.61-1.39 1.09-1.54 1.23-1.08.62-.93.62-.77.77Z"
                />
              </mask>
              <g mask="url(#contactLibrary-u)">
                <path fill="url(#contactLibrary-v)" d="M257.25 8.31h76.05V65.2h-76.05z" />
              </g>
            </g>
            <rect
              width={35.57}
              height={8.22}
              x={257.51}
              y={62.36}
              fill={templateStyles['userBackground']}
              rx={4.11}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M261.18 64.49a1.99 1.99 0 1 0 1 3.7l.22.4a2.44 2.44 0 0 1-3.67-2.12 2.45 2.45 0 1 1 4.9 0c0 .26-.09.55-.25.77a.95.95 0 0 1-.77.41.68.68 0 0 1-.65-.43c-.35.41-.92.58-1.4.31-.53-.3-.63-1.04-.3-1.6.31-.54.99-.83 1.53-.52.34.2.51.58.5.95v.04c0 .21.01.43.07.6.03.07.06.12.1.15.03.02.07.05.15.05.16 0 .3-.09.4-.23a.9.9 0 0 0 .16-.5c0-1.1-.9-1.98-1.99-1.98Zm.65 1.86c0-.24-.1-.44-.27-.54-.26-.15-.68-.04-.91.36-.23.4-.11.81.15.97.26.15.68.04.91-.36a.9.9 0 0 0 .12-.4v-.03Z"
              clipRule="evenodd"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={264.85} y={67.56}>
                Fidelis Ejima
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={257.51} y={78.23}>
                {formatMessage(contactLibraryMessages['contact-library.entry-4-cell-3'])}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={257.51} y={88.9}>
                {formatMessage(contactLibraryMessages['contact-library.entry-4-cell-4'])}
              </tspan>
            </text>
            <rect
              width={27.7}
              height={6.7}
              x={257.66}
              y={94.53}
              fill={tagBackgroundColors['greenLight']}
              rx={0.77}
            />
            <rect
              width={27.7}
              height={6.7}
              x={257.66}
              y={94.53}
              stroke={tagBorderColors['greenLight']}
              strokeWidth={0.3}
              rx={0.77}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={259.88} y={98.96}>
                {formatMessage(
                  contactLibraryMessages['contact-library.field-5-select-option-2']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={257.51} y={109.02}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-4-cell-6']
                ).substring(0, 30)}
              </tspan>
              <tspan x={256.51} y={115.14}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-4-cell-6']
                ).substring(30, 59)}
              </tspan>
              <tspan x={256.51} y={121.26}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-4-cell-6']
                ).substring(59, 89)}
              </tspan>
              <tspan x={257.51} y={127.38}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-4-cell-6']
                ).substring(89, 122)}
              </tspan>
              <tspan x={256.51} y={133.5}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-4-cell-6']
                ).substring(122, 158)}
              </tspan>
              <tspan x={256.51} y={139.62}>
                {formatMessage(
                  contactLibraryMessages['contact-library.entry-4-cell-6']
                ).substring(158, 190)}
              </tspan>
            </text>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="contactLibrary-a">
          <rect width={336} height={142} fill={templateStyles['background']} rx={3} />
        </clipPath>
        <clipPath id="contactLibrary-c">
          <rect
            width={80.94}
            height={174.28}
            x={2.45}
            y={3.67}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="contactLibrary-d">
          <path fill={templateStyles['background']} d="M2.45 3.67h80.94v53.75H2.45z" />
        </clipPath>
        <clipPath id="contactLibrary-i">
          <rect
            width={80.94}
            height={174.28}
            x={85.84}
            y={3.67}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="contactLibrary-j">
          <path fill={templateStyles['background']} d="M85.84 3.67h81v53.75h-81z" />
        </clipPath>
        <clipPath id="contactLibrary-n">
          <rect
            width={80.94}
            height={174.28}
            x={169.22}
            y={3.67}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="contactLibrary-o">
          <path fill={templateStyles['background']} d="M169.22 3.67h81v53.75h-81z" />
        </clipPath>
        <clipPath id="contactLibrary-s">
          <rect
            width={80.94}
            height={174.28}
            x={252.61}
            y={3.67}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="contactLibrary-t">
          <path fill={templateStyles['background']} d="M252.61 3.67h81v53.8h-81z" />
        </clipPath>
        <pattern
          id="contactLibrary-e"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#contactLibrary-w" transform="matrix(.002 0 0 .0023 0 -.08)" />
        </pattern>
        <pattern
          id="contactLibrary-g"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#contactLibrary-w" transform="matrix(.002 0 0 .0023 0 -.08)" />
        </pattern>
        <pattern
          id="contactLibrary-l"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#contactLibrary-x" transform="matrix(.002 0 0 .0026 0 -.16)" />
        </pattern>
        <pattern
          id="contactLibrary-q"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#contactLibrary-y" transform="matrix(.002 0 0 .0024 0 -.12)" />
        </pattern>
        <pattern
          id="contactLibrary-v"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#contactLibrary-z" transform="matrix(.002 0 0 .0026 0 -.17)" />
        </pattern>
        <filter
          id="contactLibrary-b"
          width={81.55}
          height={175.19}
          x={2.14}
          y={3.37}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_14875" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_14875"
            result="effect2_dropShadow_1228_14875"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_14875"
            result="shape"
          />
        </filter>
        <filter
          id="contactLibrary-h"
          width={81.55}
          height={175.19}
          x={85.53}
          y={3.37}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_14875" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_14875"
            result="effect2_dropShadow_1228_14875"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_14875"
            result="shape"
          />
        </filter>
        <filter
          id="contactLibrary-m"
          width={81.55}
          height={175.19}
          x={168.92}
          y={3.37}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_14875" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_14875"
            result="effect2_dropShadow_1228_14875"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_14875"
            result="shape"
          />
        </filter>
        <filter
          id="contactLibrary-r"
          width={81.55}
          height={175.19}
          x={252.31}
          y={3.37}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_14875" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_14875"
            result="effect2_dropShadow_1228_14875"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_14875"
            result="shape"
          />
        </filter>
        <image xlinkHref={annieClaire} id="contactLibrary-w" width={562} height={562} />
        <image
          xlinkHref={austinLambert}
          id="contactLibrary-x"
          width={460}
          height={570}
          x={-20}
        />
        <image xlinkHref={oliviaYang} id="contactLibrary-y" width={452} height={510} />
        <image xlinkHref={fidelisEjima} id="contactLibrary-z" width={470} height={510} />
      </defs>
    </svg>
  );
};
export default ContactLibrary;
